module.exports = __webpack_public_path__ + "static/media/feedback.866b8b43.svg";